if (!customElements.get("faqs-accordion")) {
  const DURATION = 280;
  const EASING = "ease";
  const reducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const resetAnswer = (answer) => {
    answer.style.transition = "";
    answer.style.height = "";
    answer.style.overflow = "";
    answer.style.willChange = "";
  };

  customElements.define(
    "faqs-accordion",
    class FaqsAccordion extends HTMLElement {
      connectedCallback() {
        if (this.items) return;
        this.items = Array.from(this.querySelectorAll("[data-faq]"));

        this.items.forEach((item) => {
          const summary = item.querySelector("summary");
          if (!summary) return;

          summary.addEventListener("click", (event) => {
            event.preventDefault();

            if (item.hasAttribute("open")) {
              this.close(item);
              return;
            }

            this.items.forEach((other) => {
              if (other !== item && other.hasAttribute("open")) this.close(other);
            });

            this.open(item);
          });
        });
      }

      open(item) {
        const answer = item.querySelector("[data-faq-answer]");
        const inner = item.querySelector("[data-faq-answer-inner]");

        item.setAttribute("open", "");
        if (!answer || !inner || reducedMotion()) return;

        answer.style.overflow = "hidden";
        answer.style.willChange = "height";
        answer.style.height = "0px";

        // Read layout so the browser commits the 0px height before the transition starts.
        answer.offsetHeight;

        answer.style.transition = `height ${DURATION}ms ${EASING}`;
        answer.style.height = inner.scrollHeight + "px";

        const onEnd = (event) => {
          if (event.target !== answer) return;
          answer.removeEventListener("transitionend", onEnd);
          resetAnswer(answer);
        };
        answer.addEventListener("transitionend", onEnd);
      }

      close(item) {
        if (!item.hasAttribute("open")) return;

        const answer = item.querySelector("[data-faq-answer]");
        const inner = item.querySelector("[data-faq-answer-inner]");

        if (!answer || !inner || reducedMotion()) {
          item.removeAttribute("open");
          return;
        }

        answer.style.overflow = "hidden";
        answer.style.willChange = "height";
        answer.style.height = inner.scrollHeight + "px";

        answer.offsetHeight;

        answer.style.transition = `height ${DURATION}ms ${EASING}`;
        answer.style.height = "0px";

        const onEnd = (event) => {
          if (event.target !== answer) return;
          answer.removeEventListener("transitionend", onEnd);
          item.removeAttribute("open");
          resetAnswer(answer);
        };
        answer.addEventListener("transitionend", onEnd);
      }
    },
  );
}
